module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('p', {
    staticStyle: {
      "font-family": "Calisto MT",
      "text-align": "center",
      "font-weight": "bold",
      "font-size": "18pt",
      "letter-spacing": "1px",
      "padding-top": "60px",
      "padding-bottom": "20px"
    }
  }, [_vm._v("Dedication")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("To my beloved Layla, Troy, and Libby who we all miss so much, but never forgotten in our hearts, it has been an honour and pleasure to have known you, and to call friends, God Bless you.")]), _vm._v(" "), _c('p', [_vm._v("To those wonderful people/organisations, and the indigenous tribes who care for the animals, plants and their habitats that we share, thank you.")]), _vm._v(" "), _c('p', [_vm._v("To all those animal lovers who have lost their wonderful pets, to their current pets and the wonderful wildlife of our world who we share with, thank you, the world would not be the same without all of you.")]), _vm._v(" "), _c('p', [_vm._v("To our beloved Honey, Bramble, and Ollie.")]), _vm._v(" "), _c('p', [_vm._v("To also thank the publisher Austin Macauley and their staff from the bottom of my heart for making this dream come true.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ab9d586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 66
// module chunks = 0